module.exports = __webpack_public_path__ + "h5/img/sign.78746c05.gif";